module.exports = __webpack_public_path__ + "static/media/edit.91927884.svg";